import { Request } from "@xt/xtbase";
const { XtAxios4 } = Request;

const URL = "/exapi/price/";

// 获取市值排序币种列表
export function get_currencyPage(config?) {
  return XtAxios4.get(URL + `public/currency/page`, config);
}

// 获取币种信息
export function get_currencyPrice(currency: string, config?) {
  return XtAxios4.get(URL + `public/currency/price/${currency}`, config);
}

// 获取法币间转换汇率
export function get_currencyExchangeRate(config?) {
  return XtAxios4.get(URL + `public/currency/exchange-rate`, config);
}

// 获取图表数据
export function get_currencyMarketChart(config?) {
  return XtAxios4.get(URL + `public/currency/market-chart`, config);
}

// 判断币种是否开放价格详情信息查看
export function get_currencyCgSupported(currency, config?) {
  return XtAxios4.get(URL + `public/currency/supported?currency=${currency}`, config);
}
